import { useState } from "react";
import * as authApi from "../api/auth";
import { APIConnectionError } from "../api/errors";
import { changePasswordProblem } from "../auth-validation";
import { Dialog, MessageBox } from "../ui/Dialog";
import { PasswordInput } from "../ui/PasswordInput";

/** change_password_dialog.py */
export function ChangePasswordDialog({ onClose, onDone }: { onClose: () => void; onDone: () => void }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    const problem = changePasswordProblem(current, next, confirm);
    if (problem) { setError(problem); return; }
    setBusy(true);
    try {
      await authApi.changePassword(current, next);
      setDone(true);
    } catch (e) {
      setError(e instanceof APIConnectionError ? `Connection error: ${e.detail}` : (e as Error).message);
    } finally { setBusy(false); }
  };

  if (done) return <MessageBox title="Password Changed" text="Your password has been updated." onClose={() => { onDone(); onClose(); }} />;
  return (
    <Dialog title="Change Password" onClose={onClose} testId="change-password">
      <div className="form-row"><label htmlFor="cp-cur">Current password</label><PasswordInput id="cp-cur" value={current} onChange={setCurrent} /></div>
      <div className="form-row"><label htmlFor="cp-new">New password</label><PasswordInput id="cp-new" value={next} onChange={setNext} autoComplete="new-password" /></div>
      <div className="form-row"><label htmlFor="cp-conf">Confirm new password</label><PasswordInput id="cp-conf" value={confirm} onChange={setConfirm} onEnter={submit} autoComplete="new-password" /></div>
      <div className="error-text" role="alert" data-testid="cp-error">{error}</div>
      <div className="dialog-actions">
        <button className="btn" onClick={onClose}>Cancel</button>
        <button className="btn primary" disabled={busy} onClick={submit}>{busy ? "Changing…" : "Change Password"}</button>
      </div>
    </Dialog>
  );
}
